'use client';
import { ThemeProvider } from '@/components/ThemeProvider';
import { AuthProvider } from '@/components/AuthProvider';
import AppShell from '@/components/AppShell';
import LoginScreen from '@/components/LoginScreen';

export default function ClientLayout({ children }) {
  return (
    <ThemeProvider>
      <AuthProvider
        loginView={<LoginScreen />}
        appView={<AppShell>{children}</AppShell>}
      />
    </ThemeProvider>
  );
}